<template>
  <div>
    <h1>权限不足，请联系管理员！</h1>
    <h4>{{tip}}</h4>
    <router-link :to="sysPath" style="float: left;font-size: 18px">{{sysName}}</router-link>
    <router-link to="/login" style="float: right;font-size: 18px">回到登陆</router-link>
  </div>
</template>

<script>
  export default {
    name: "noRight",
    data() {
      return {
        tip: '',

        sysPath: '/',
        sysName: '',
      }
    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        this_.loadData();
      });
    },
    methods: {
      loadData(){
        let this_ = this;
        switch (this_.$store.state.userCode){
          case this_.$store.state.easUserCode:
            this_.tip = "（您暂时的权限只允许访问教务端，请您确定您输入的账号或者输入的地址是否正确）";
            this_.sysPath = "/index";
            this_.sysName = "点击此处进入教务端首页";
            break;
          case this_.$store.state.teacherClassUserCode:
            this_.tip = "（您暂时没有权限访问本系统，请您确定您输入的账号是否正确）";
            break;
          case this_.$store.state.teacherUserCode:
            this_.tip = "（您暂时的权限只允许访问教师端，请您确定您输入的账号或者输入的地址是否正确）";
            this_.sysPath = "/index_tea";
            this_.sysName = "点击此处进入教师端首页";
            break;
          case this_.$store.state.studentUserCode:
            this_.tip = "（您暂时的权限只允许访问学员端，请您确定您输入的账号或者输入的地址是否正确）";
            this_.sysPath = "/homeworkManage_stu";
            this_.sysName = "点击此处进入学员端首页";
            break;
          default:
            this_.tip = "（您暂时没有权限访问本系统，请您确定您输入的账号是否正确）";
            break;
        }
      }
    }
  }
</script>

<style scoped>
  div {
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, 0);
  }
  div h1 {
    text-align: center;
  }
  div h4 {
    margin-bottom: 100px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/noRight.vue